import notFoundComponent from "@views/error/404.vue";

const errorRouter = [{
  path: '*', //404
  component: notFoundComponent
}];

export default errorRouter;



// WEBPACK FOOTER //
// ./src/router/error/index.js